<template>
  <div class="p-1 space-y-6" dir="rtl">
    <div
        class="fixed top-4 left-1/2 -translate-x-1/2 z-[9999] space-y-2 w-[92vw] max-w-sm"
        aria-live="assertive" aria-atomic="true"
    >
      <transition-group name="toast" tag="div">
        <div
            v-for="t in toasts" :key="t.id"
            class="rounded-md border shadow-md px-3 py-2 text-sm flex items-start gap-2"
            :class="t.type==='error'
              ? 'bg-rose-50 border-rose-200 text-rose-800'
              : 'bg-emerald-50 border-emerald-200 text-emerald-800'"
            role="alert"
        >
          <div class="mt-[2px]">
            <span v-if="t.type==='error'">⚠️</span>
            <span v-else>✅</span>
          </div>
          <div class="flex-1 leading-5">{{ t.message }}</div>
          <button class="text-xs text-gray-500 hover:text-gray-700" @click="removeToast(t.id)">بستن</button>
        </div>
      </transition-group>
    </div>
    <section class="rounded-2xl border border-gray-200 p-4 space-y-4 bg-white">
      <div class="flex items-center justify-between">
        <div class="space-y-1">
          <h1 class="text-md font-bold">تحویل پکینگ</h1>
          <p class="text-xs text-gray-500">شناسه پکینگ: {{ packageId }}</p>
        </div>
      </div>

      <div v-if="!session" class="grid grid-cols-5 gap-3">
        <div>
          <label class=" text-xs text-gray-700">انبار مقصد : </label>
          <select v-model="selectedStoreId"
                  class="bg-gray-100 shadow-sm text-gray-900 text-xs border-1 rounded-lg p-2 border-blue-900 ">
            <option :value="null">— انتخاب کنید —</option>
            <option v-for="st in stores" :key="st.id" :value="st.id">{{ st.name }}</option>
          </select>
        </div>
        <div>
          <label class=" text-xs text-gray-700">نام راننده : </label>
          <input placeholder="نام راننده" type="text" v-model.trim="openForm.driver_name"
                 class="bg-gray-100 shadow-sm text-center text-gray-900 text-xs border-1 rounded-lg p-2 border-blue-900"/>
        </div>
        <div>
          <label class=" text-xs text-gray-700"> موبایل راننده : </label>
          <input type="text" placeholder="موبایل راننده" v-model.trim="openForm.driver_mobile_number"
                 class="bg-gray-100 shadow-sm text-center text-gray-900 text-xs border-1 rounded-lg p-2 border-blue-900"/>
        </div>
        <div>
          <label class=" text-xs text-gray-700">شماره رسید : </label>
          <input type="text" placeholder="شماره رسید" v-model.trim="openForm.document_number"
                 class="bg-gray-100 shadow-sm text-center text-gray-900 text-xs border-1 rounded-lg p-2 border-blue-900"/>
        </div>
        <div class=" flex items-center justify-end">
          <button class="px-2 py-1 text-blue-50 bg-blue-500 rounded-lg" @click="openSession">
            شروع تحویل
          </button>
        </div>
      </div>

      <div v-else class="md:flex md:flex-wrap xl:flex-nowrap items-end gap-2">
        <div class="w-full md:w-28">
          <span class="block text-xs text-gray-700 mb-1">وضعیت</span>
          <div class="flex items-center">
            <span class="px-3 py-1 rounded-full text-xs border" :class="session.is_closed ? 'bg-gray-50 text-gray-700 border-gray-200' : 'bg-emerald-50 text-emerald-700 border-emerald-200'">
              {{ session.is_closed ? 'نهایی شده' : 'درحال تحویل' }}
            </span>
          </div>
        </div>
        <div class="w-full md:w-44">
          <span class="block text-xs text-gray-700 mb-1">تاریخ شروع</span>
          <div class="bg-gray-100 shadow-sm text-center text-gray-900 text-xs border-1 rounded-lg p-2 border-blue-900">
            {{ session.last_activity_at }}
          </div>
        </div>

        <div class="w-full md:w-44">
          <span class="block text-xs text-gray-700 mb-1">آخرین فعالیت</span>
          <div class="bg-gray-100 shadow-sm text-center text-gray-900 text-xs border-1 rounded-lg p-2 border-blue-900">
            {{ session.last_activity_at }}
          </div>
        </div>
        <div class="w-full md:w-40">
          <label class="block text-xs text-gray-700 mb-1">نام راننده</label>
          <input type="text" v-model.trim="openForm.driver_name"
                 :disabled="session.is_closed"
                 class="bg-gray-100 shadow-sm text-gray-900 text-xs border-1 rounded-lg p-2 border-blue-900"/>
        </div>
        <div class="w-full md:w-40">
          <label class="block text-xs text-gray-700 mb-1">شماره رسید</label>
          <input type="text" v-model.trim="openForm.document_number"
                 :disabled="session.is_closed"
                 class="bg-gray-100 shadow-sm text-gray-900 text-xs border-1 rounded-lg p-2 border-blue-900"/>
        </div>

        <div class="w-full md:w-52">
          <label class="block text-xs text-gray-700 mb-1">انبار مقصد</label>
          <select v-model="selectedStoreId"
                  @change="openForm.to_store_id = selectedStoreId"
                  :disabled="session.is_closed"
                  class="w-full bg-gray-100 shadow-sm text-gray-900 text-xs border-1 rounded-lg p-2 border-blue-900">
            <option :value="null">— انتخاب انبار —</option>
            <option v-for="st in stores" :key="st.id" :value="st.id">{{ st.name }}</option>
          </select>
          <div v-if="selectedStoreId" class="mt-1">
          </div>
        </div>
        <div class="w-full md:w-auto md:ml-auto">
          <button class="px-3 py-2 text-white bg-pink-600 rounded-lg w-full md:w-auto"
                  @click="closeSession"
                  :disabled="closing || session.is_closed">
            پایان تحویل
          </button>
        </div>
      </div>
    </section>

    <section v-if="session && !session.is_closed" class="rounded-lg border border-gray-200 p-4 bg-white">
      <h2 class="text-base font-semibold mb-4">انتخاب آیتم با SKU و ثبت تعداد</h2>

      <div class="flex flex-col gap-3">
        <div class="flex-1 min-w-0">
          <label class="block text-sm font-medium text-gray-700 mb-1">جست‌وجوی SKU</label>
          <div class="relative">
            <input
                type="text"
                class="w-full px-3 py-2 pr-8 rounded-lg ring-2 focus:ring-emerald-400 text-gray-800 placeholder-gray-400 text-sm"
                v-model.trim="skuSearch"
                placeholder="sku search ... "
                @input="onSkuTyping"
                @keydown.down.prevent="moveSuggest(1)"
                @keydown.up.prevent="moveSuggest(-1)"
                @keydown.enter.prevent="chooseSuggest()"
                @keydown.esc.prevent="clearSelected()"
            />
            <button
                v-if="skuSearch"
                class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors duration-200 p-0.5 rounded"
                @click="clearSelected"
                title="پاک کردن"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>

          <div v-if="showSuggest" class="absolute z-50 mt-1 w-[70wh] bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-auto">
            <div
                v-for="(s, idx) in suggestList"
                :key="s.item_id"
                class="px-3 py-2 text-sm cursor-pointer flex items-center border-b border-gray-100 last:border-b-0 transition-colors duration-150"
                :class="[
          idx === suggestIndex ? 'bg-emerald-50 text-emerald-800' : 'text-gray-700 hover:bg-gray-50',
          (Number(s.remaining || 0) <= 0) ? 'opacity-60 pointer-events-none' : ''
        ]"
                @mousedown.prevent="selectRow(s)"
            >
              <div class="flex items-center gap-2 flex-1 min-w-0">
                <img @click.stop="openImagePreview(img_source(s.image))"
                     v-if="s.image"
                     :src="img_source(s.image)"
                     class="w-6 h-6 rounded border object-cover flex-shrink-0"/>
                <div class="leading-tight min-w-0 flex-1">
                  <div class="font-mono text-lg text-gray-900 truncate">{{ s.sku }}</div>
                  <div class="text-xs text-gray-500 truncate">{{ s.name }}</div>
                </div>
              </div>
              <span class="px-2 py-0.5 ml-1 rounded-lg text-md mr-3" :class="Number(s.remaining||0) > 0 ? 'bg-blue-100 text-gray-700' : 'bg-emerald-100 text-emerald-800'">
          {{ Number(s.remaining||0) > 0 ? ('باقیمانده : ') : 'تکمیل' }}
          <span class="text-lg font-bold" v-if="Number(s.remaining||0) > 0">{{ s.remaining }}</span>
        </span>
            </div>
            <div v-if="showSuggest && !suggestList.length" class="px-3 py-3 text-center">
              <div class="text-xs text-gray-500">موردی یافت نشد</div>
            </div>
          </div>
        </div>

        <div v-if="selectedItem" class="grid grid-cols-12 gap-2 items-end">
          <div v-if="selectedItem" class="mt-2 flex items-center gap-2  rounded-lg"
            :class="editingName? 'col-span-3': 'col-span-2'"
          >
            <img
                @click.stop="openImagePreview(img_source(selectedItem.image))"
                v-if="selectedItem.image"
                :src="img_source(selectedItem.image)"
                alt="item"
                class="w-8 h-8 object-cover rounded-md border"
            />
            <div v-if="!editingName" class="flex items-center gap-2">
              <input
                  type="text"
                  :value="selectedItem.name || ''"
                  class="w-full px-3 py-2 rounded-lg bg-gray-100 text-gray-800 text-sm"
                  disabled
              />
              <button
                  class="px-2 py-2 rounded-md ring-1 ring-gray-300 text-gray-700 hover:bg-gray-50"
                  @click.stop="startEditName"
                  :disabled="session && session.is_closed"
                  title="ویرایش نام"
                  aria-label="ویرایش نام"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24"
                     fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 20h9"/>
                  <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"/>
                </svg>
              </button>
            </div>

            <div v-else class="flex items-center gap-2">
              <input
                  type="text"
                  v-model.trim="newName"
                  class="w-full px-3 py-2 rounded-lg ring-2 focus:ring-emerald-400 text-sm"
                  placeholder="نام جدید آیتم"
                  :disabled="savingName"
                  @keydown.enter.prevent="saveNameChange"
                  @keydown.esc.prevent="cancelEditName"
              />
              <button
                  class="px-3 py-2 rounded-md bg-emerald-600 text-white text-sm disabled:bg-gray-400"
                  @click="saveNameChange"
                  :disabled="!newName || savingName"
                  title="ذخیره"
              >
                ذخیره
              </button>
              <button
                  class="px-3 py-2 rounded-md bg-gray-100 text-gray-700 text-sm"
                  @click="cancelEditName"
                  :disabled="savingName"
                  title="انصراف"
              >
                انصراف
              </button>
            </div>
          </div>
          <div class="col-span-3">
            <label class="block text-xs text-gray-700 mb-1">SKU</label>

            <div v-if="!editingSku" class="flex items-center gap-2">
              <input
                  type="text"
                  :value="selectedItem.sku"
                  class="w-full px-3 py-2 rounded-lg bg-gray-100 text-gray-800 text-sm font-mono"
                  disabled
              />
              <button
                  class="px-2 py-2 rounded-md ring-1 ring-gray-300 text-gray-700 hover:bg-gray-50"
                  @click.stop="startEditSku"
                  :disabled="session && session.is_closed"
                  title="ویرایش SKU"
                  aria-label="ویرایش SKU"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24"
                     fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 20h9"/>
                  <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"/>
                </svg>
              </button>
                <div class="relative" ref="printDropdownContainer">
                  <button
                      class="px-2 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg text-xs flex items-center gap-1"
                      @click="togglePrintDropdown"
                      :disabled="!selectedItem"
                      title="پرینت لیبل"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"/>
                    </svg>

                  </button>

                  <!-- Dropdown menu -->
                  <div v-if="showPrintDropdown && selectedItem"
                       class="absolute left-0 mt-1 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-50 py-1">
                    <button
                        class="w-full text-right px-4 py-2 text-sm text-gray-700 hover:bg-purple-50 hover:text-purple-700 flex items-center gap-2"
                        @click="printLabel('price')"
                    >
                      <span class="text-xs">💰</span>
                      لیبل بارکد
                    </button>
                    <button
                        class="w-full text-right px-4 py-2 text-sm text-gray-700 hover:bg-purple-50 hover:text-purple-700 flex items-center gap-2"
                        @click="printLabel('tester')"
                    >
                      <span class="text-xs">🧪</span>
                      لیبل تستر
                    </button>
                    <button
                        class="w-full text-right px-4 py-2 text-sm text-gray-700 hover:bg-purple-50 hover:text-purple-700 flex items-center gap-2"
                        @click="printLabel('gtn')"
                    >
                      <span class="text-xs">🏷️</span>
                      لیبل اصالت
                    </button>
                    <div class="border-t border-gray-100 my-1"></div>
                  </div>
                </div>

            </div>

            <div v-else class="flex items-center gap-2">
              <input
                  type="text"
                  v-model.trim="newSku"
                  class="flex-1 px-3 py-2 rounded-lg ring-2 focus:ring-emerald-400 text-sm font-mono"
                  placeholder="SKU جدید"
                  :disabled="savingSku"
                  ref="editSkuInput"
                  @keydown.enter.prevent="saveSkuChange"
                  @keydown.esc.prevent="cancelEditSku"
              />
              <button
                  type="button"
                  class="px-3 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-colors"
                  @click="generateSku"
                  title="تولید SKU تصادفی"
                  :disabled="savingSku"
              >
                🎲
              </button>
              <button
                  class="px-3 py-2 rounded-md bg-emerald-600 text-white text-sm disabled:bg-gray-400"
                  @click="saveSkuChange"
                  :disabled="!newSku || savingSku"
                  title="ذخیره"
              >
                ذخیره
              </button>
              <button
                  class="px-3 py-2 rounded-md bg-gray-100 text-gray-700 text-sm"
                  @click="cancelEditSku"
                  :disabled="savingSku"
                  title="انصراف"
              >
                انصراف
              </button>
            </div>
          </div>
          <div :class="editingPlanned || !editingName? 'col-span-2': 'col-span-1'">
            <label class="block text-xs text-gray-700 mb-1">تعداد کل</label>

            <div v-if="!editingPlanned" class="flex items-center gap-2">
              <div class="w-full px-3 py-2 rounded-lg bg-gray-100 text-center text-sm">
                {{ selectedPlanned }}
              </div>
              <button
                  class="px-2 py-2 rounded-md ring-1 ring-gray-300 text-gray-700 hover:bg-gray-50"
                  @click.stop="startEditPlanned"
                  :disabled="session && session.is_closed"
                  title="ویرایش تعداد کل"
                  aria-label="ویرایش تعداد کل"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4"
                     viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 20h9"/>
                  <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"/>
                </svg>
              </button>
            </div>

            <div v-else class="flex items-center gap-2">
              <input
                  type="number"
                  v-model.number="newPlanned"
                  min="0"
                  class="w-full px-3 py-2 rounded-lg ring-2 focus:ring-emerald-400 text-sm text-center"
                  placeholder="تعداد کل جدید"
                  :disabled="savingPlanned"
                  @keydown.enter.prevent="savePlannedChange"
                  @keydown.esc.prevent="cancelEditPlanned"
              />
              <button
                  class="px-3 py-2 rounded-md bg-emerald-600 text-white text-sm disabled:bg-gray-400"
                  @click="savePlannedChange"
                  :disabled="newPlanned == null || newPlanned < 0 || savingPlanned"
                  title="ذخیره"
              >
                ذخیره
              </button>
              <button
                  class="px-3 py-2 rounded-md bg-gray-100 text-gray-700 text-sm"
                  @click="cancelEditPlanned"
                  :disabled="savingPlanned"
                  title="انصراف"
              >
                انصراف
              </button>
            </div>
          </div>
          <div class="md:col-span-1">
            <label class="block text-xs text-gray-700 mb-1"> تحویل از پارت  قبل</label>
            <div class="w-full px-3 py-2 rounded-lg bg-gray-100 text-center text-sm">
              {{ selectedDeliveredToDate }}
            </div>
          </div>

          <div class="md:col-span-1 cursor-pointer" @click.stop="openLinesModal(selectedItem)">
            <label class="block text-xs text-gray-700 mb-1">جمع تحویل در این پارت </label>
            <div class="w-full px-3 py-2 rounded-lg bg-gray-100 text-center text-sm">
              {{ selectedCountedInThisSession }}
            </div>
          </div>

          <div class="col-span-1">
            <label class="block text-xs text-gray-700 mb-1">تعداد</label>
            <input
                type="number"
                class="w-full px-3 py-2 rounded-lg ring-2 focus:ring-emerald-400 text-sm text-center"
                min="0"
                :max="Math.max(1, selectedRemaining)"
                v-model.number="scanQty"
                @input="clampQty"
                @keydown.enter.prevent="addSelected()"
                :disabled="selectedRemaining <= 0"
                placeholder="تعداد"
            />
          </div>
          <div class="col-span-1">
            <label class="block text-xs text-gray-700 mb-1">باقی‌مانده</label>
            <div
                class="w-full px-3 py-2 rounded-lg text-center text-sm font-bold"
                :class="displayRemaining > 0 ? 'bg-amber-50 text-amber-800 ring-1 ring-amber-200' : 'bg-emerald-50 text-emerald-800 ring-1 ring-emerald-200'"
            >
              {{ displayRemaining }}
              <span class="text-[9px] text-gray-500 mr-1">از {{ selectedRemaining }}</span>
            </div>
          </div>


          <div class="md:col-span-1 flex gap-2">
            <button
                class="px-3 py-2 text-center bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm w-full disabled:bg-gray-400 disabled:cursor-not-allowed"
                :disabled="!canAdd"
                @click="addSelected"
            >
              ثبت
            </button>
            <button
                class="px-3 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg text-sm"
                @click="clearSelected"
                title="تغییر آیتم"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>
        </div>

      </div>
    </section>
    <section v-if="session" class="rounded-md border border-gray-200 overflow-hidden bg-white">
      <div class="flex bg-gray-900 justify-between">
        <p class="font-semibold text-white px-2 mt-2">آمار آیتم‌ها</p>
        <v-spacer></v-spacer>
        <div class="relative flex left-0 gap-2 ml-2">
          <v-spacer></v-spacer>
          <button
              v-if="!selectionMode"
              class="px-2 my-2 text-xs rounded-md bg-indigo-700 text-white hover:bg-indigo-600"
              @click="toggleSelectionMode(true)"
              title="شروع یک پارچه سازی گروه متغیر"
          >
            شروع یک پارچه سازی گروه متغیر
          </button>
          <template v-else>
            <div class="relative">
              <div
                  v-if="showSelectionDropdown"
                  class="absolute left-0 mt-2 w-[62vw] max-w-xl bg-white border border-gray-200 rounded-lg shadow-lg z-50 p-2"
              >
                <div class="flex justify-between mb-2">
                  <div class="text-xs text-gray-600">اقلام انتخاب‌شده: {{ selectedIds.length }}</div>
                  <v-spacer></v-spacer>
                  <div class="flex gap-2">
                    <v-spacer></v-spacer>
                    <button
                        class="px-2 m-1 py-1 text-xs rounded bg-red-50 text-red-800 ring-1 ring-red-800"
                        @click="clearSelection"
                    >
                      پاک‌ کردن همه
                    </button>
                    <button
                        class="px-2 py-1 m-1 text-xs rounded bg-gray-50 text-gray-700 ring-1 ring-gray-700"
                        @click="showSelectionDropdown = false"
                    >
                      بستن
                    </button>
                  </div>
                </div>

                <div class="max-h-60 overflow-auto space-y-2">
                  <div
                      v-for="it in selectedItems"
                      :key="it.item_id"
                      class="flex items-center gap-2 p-2 rounded border border-gray-200"
                  >
                    <img
                        @click.stop="openImagePreview(img_source(it.image))"
                        v-if="it.image"
                        :src="img_source(it.image)"
                        class="w-8 h-8 rounded border object-cover" />
                    <div class="flex-1 min-w-0">
                      <div class="text-[11px] text-gray-800 truncate font-mono">{{ it.sku || '-' }}</div>
                      <div class="text-[10px] text-gray-500 truncate">{{ it.name }}</div>
                    </div>
                    <button
                        class="text-xs px-1 py-1 rounded bg-red-100 ring-1 ring-red-300 text-red-700"
                        @click="removeFromSelection(it.item_id)"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                      </svg>
                    </button>
                  </div>

                  <div v-if="!selectedItems.length" class="text-center text-xs text-gray-400 py-6">
                    موردی انتخاب نشده است.
                  </div>
                </div>
              </div>
            </div>
            <button
                v-if="selectedIds.length"
                class="px-2 my-2 text-xs text-xs rounded-md bg-blue-700 text-blue-50 hover:bg-blue-600"
                @click="showSelectionDropdown = !showSelectionDropdown"
                title="مشاهده انتخاب ها"
            >
              انتخاب ها ({{ selectedIds.length }}) ▾
            </button>
            <span
                v-if="!selectedIds.length"
                class="px-2 pt-2 my-2 text-[10px] text-xs rounded-md bg-gray-700 text-gray-50 hover:bg-gray-600"
            >
              آیتم ها را از جدول انتخاب کنید
            </span>

            <button
                class="px-2 my-2 text-xs rounded bg-rose-800 text-rose-100 ring-1 ring-rose-700"
                @click="toggleSelectionMode(false)"
            >
              خروج از ویرایش نوع
            </button>
            <button
                v-if="selectedIds.length"
                class="px-2 my-2 text-xs rounded-md bg-emerald-700 text-white hover:bg-emerald-600"
                @click="openVariationModalBulk"
                title="ادامه برای اقلام انتخاب‌شده"
            >
              ثبت یک پارچه سازی گروه متغیر
            </button>
          </template>
        </div>
      </div>
      <div class="overflow-auto max-h-[65vh]">
        <table class="min-w-full text-sm text-right">
          <thead class="bg-gray-700 text-gray-100 sticky top-0 z-20">
          <tr>
            <th class="text-xs font-thin text-gray-100 text-center w-8" v-if="selectionMode">
              <input type="checkbox" :checked="isAllSelected" @change="toggleSelectAll" />
            </th>
            <th class="text-xs font-thin text-gray-100 text-center">تصویر</th>
            <th class="text-xs font-thin text-gray-100 text-center">SKU</th>
            <th class="text-xs font-thin text-gray-100 text-center">نوع</th>
            <th class="text-xs font-thin text-gray-100 text-center">نام</th>
            <th class="text-xs font-thin text-gray-100 text-center">تعداد کل</th>
            <th class="text-xs font-thin text-gray-100 text-center">تحویل از پارت  قبل</th>
            <th class="text-xs font-thin text-gray-100 text-center">جمع تحویل در این پارت</th>
            <th class="text-xs font-thin text-orange-100 text-center bg-orange-600">شمارش شده این تحویل</th>
            <th class="text-xs font-thin text-gray-100 text-center">باقی‌مانده</th>
            <th class="text-xs font-thin text-gray-100 text-center"></th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(it, idx) in sortedItems"
              :key="it.item_id"
              class="border-t transition-colors cursor-pointer"
              :class="rowClasses(it, idx)"
              :style="rowStyle(it, idx)"
              @click="selectRow(it)"
          >
            <td v-if="selectionMode" class="text-center" @click.stop>
              <input type="checkbox" :value="it.item_id" v-model="selectedIds" />
            </td>
            <td class="td">
              <div
                  class="w-12 h-12 rounded-lg bg-gray-100 border overflow-hidden flex items-center justify-center ma-1">
                <img
                    @click.stop="openImagePreview(img_source(it.image))"
                    v-if="it.image"
                    :src="img_source(it.image)"
                    alt="item"
                    class="w-full h-full object-cover"/>
                <span v-else class=" text-center text-[10px] text-gray-400">No Image</span>
              </div>
            </td>
            <td class=" text-[15px] font-semibold text-center">{{ it.sku || '-' }}</td>
            <td class="text-center" @click.stop="selectItemTypeForChange(it)">
              <span
                  class="px-2 py-0.5 rounded-full text-[10px] border cursor-pointer"
                  :class="it.type==='variation' ? 'bg-purple-500 text-purple-50 border-purple-400' : 'bg-pink-500 text-pink-50 border-pink-400'"
                  title="ویرایش نوع "
              >
                {{ it.type === 'variation' ? 'متغیر' : 'ساده' }}
              </span>
            </td>
            <td class="text-[10px] text-center">
              <span class=" font-bold text-[12px]" v-if="it.variation_of_product_name">
                {{it.variation_of_product_name}}
              </span>
              <br>
              <span class=" font-bold text-[8px]" v-if="it.variation_of_product_name">متغیر : </span>
              {{ it.name }}
            </td>
            <td class="td text-center">{{ it.planned }}</td>
            <td class="td text-center">{{ it.delivered_to_date }}</td>
            <td :class="Number(it.remaining||0) <= 0 ? '' : 'bg-gray-100'" @click.stop="openLinesModal(it)">
              <div class="flex items-center gap-1 justify-center flex-wrap">
                <button
                    v-for="ln in lastLinesForItem(it.item_id, 5)"
                    :key="ln.id"
                    class="inline-flex items-center mx-0.5 px-2 py-0.5 rounded-md ring-1 ring-green-900 bg-green-800 text-white text-[10px]"
                    :title="ln.qty"
                >
                  <span class="font-bold">{{ ln.qty }}</span>
                </button>

                <span v-if="!lastLinesForItem(it.item_id, 4).length"
                      class="text-[8px] text-gray-400"> در این تحویل ثبتی ندارد </span>
              </div>
            </td>
            <td class="td text-center">{{ it.counted_in_this_session }}</td>
            <td class="font-bold text-md text-center">
              <span v-if="it.remaining > 0" class="bg-red-100 text-red-800 py-1 px-2 rounded-md">
                {{it.remaining}}
              </span>
              <span v-else class="bg-emerald-100 text-emerald-800 py-1 px-2 rounded-md">
                تکمیل
              </span>

            </td>
            <td class="text-center">
              <button
                  v-if="!session.is_closed"
                  class="px-2 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700"
                  @click.stop="openSplitModal(it)"
                  title="متغیر سازی"
              >
                متغیر سازی
              </button>
            </td>

          </tr>
          <tr v-if="!items.length && !loading.items">
            <td colspan="7" class="td text-center text-gray-400">آیتمی یافت نشد</td>
          </tr>
          </tbody>
        </table>
      </div>
    </section>
    <div
        v-if="showLinesModal && linesModalItem"
        class="fixed inset-0 z-[9998] flex items-center justify-center"
        @click.self="closeLinesModal"
    >
      <div class="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>

      <div class="relative bg-white rounded-xl shadow-xl w-[92vw] max-w-2xl p-4">
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-semibold">
            ردیف‌های آیتم
            <span class="font-mono text-gray-500">({{ linesModalItem.sku || '-' }})</span>
          </h3>
          <button class="text-gray-500 hover:text-gray-700 text-sm" @click="closeLinesModal">بستن</button>
        </div>

        <div class="rounded-lg border border-gray-200 overflow-auto">
          <table class="min-w-full text-xs text-right">
            <thead class="bg-gray-50">
            <tr>
              <th class="px-2 py-2 text-gray-600 text-center">تصویر</th>
              <th class="px-2 py-2 text-gray-600 text-center">SKU</th>
              <th class="px-2 py-2 text-gray-600 text-center">تعداد</th>
              <th class="px-2 py-2 text-gray-600 text-center">زمان</th>
              <th class="px-2 py-2 text-gray-600 text-center">حذف</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="ln in linesForItemId(linesModalItem.item_id)"
                :key="ln.id"
                class="border-t"
            >
              <td class="px-2 py-2">
                <div class="w-8 h-8 rounded border bg-gray-100 overflow-hidden mx-auto">
                  <img
                      @click.stop="openImagePreview(img_source(ln.image))"
                      v-if="ln.image"
                      :src="img_source(ln.image)" class="w-full h-full object-cover" />
                </div>
              </td>
              <td class="px-2 py-2 text-center font-mono">{{ ln.sku }}</td>
              <td class="px-2 py-2 text-center">{{ ln.qty }}</td>
              <td class="px-2 py-2 text-center text-gray-500">{{ ln.created_at }}</td>
              <td class="px-2 py-2 text-center">
                <button
                    class="text-red-600 hover:text-red-700"
                    :disabled="session && session.is_closed"
                    @click="undoLine(ln.id)"
                    title="حذف"
                >
                  ✕
                </button>
              </td>
            </tr>

            <tr v-if="!linesForItemId(linesModalItem.item_id).length">
              <td colspan="5" class="px-2 py-4 text-center text-gray-400">
                ردیفی ثبت نشده
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="mt-3 flex items-center justify-end">
          <button class="px-3 py-1.5 rounded-lg bg-gray-800 text-white text-xs" @click="closeLinesModal">
            تایید
          </button>
        </div>
      </div>
    </div>

    <div
        v-if="showVarModal"
        class="fixed inset-0 z-[9998] flex items-center justify-center"
        @click.self="closeVarModal"
    >
      <div class="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>

      <div class="relative bg-white rounded-xl shadow-xl w-[92vw] max-w-xl p-4">
        <!-- Header -->
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-semibold">
            تغییر نوع محصول
          </h3>
          <button class="text-gray-500 hover:text-gray-700 text-sm" @click="closeVarModal">
            بستن
          </button>
        </div>

        <div class="space-y-4">
          <!--
          <div class="w-full">
            <div class="inline-flex rounded-lg ring-1 ring-gray-200 overflow-hidden bg-gray-50">
              <button
                  type="button"
                  class="px-3 gray--text py-1.5 text-xs transition"
                  :class="varForm.type==='variation'
              ? 'bg-purple-500 white--text'
              : 'gray--text '"
                  @click="varForm.type='variation'"
              >
                تغییر نوع به متغیر
              </button>

              <button
                  type="button"
                  class="px-3 gray--text py-1.5 text-xs transition"
                  :class="varForm.type==='simple'
              ? 'bg-pink-500 white--text'
              : 'gray--text hover:bg-gray-100'"
                  @click="varForm.type='simple'"
              >
                تغییر نوع به ساده
              </button>
            </div>
          </div>
          -->

          <div v-if="varForm.type==='variation'" class="rounded-lg ring-1 ring-gray-200 p-3 space-y-3 bg-gray-50">
            <div class="inline-flex rounded-md ring-1 ring-gray-200 overflow-hidden bg-white">
              <button
                  type="button"
                  class="px-3 py-1.5 text-xs transition"
                  :class="varForm.mode==='fk'
              ? 'bg-indigo-200 text-white'
              : 'text-gray-700 hover:bg-gray-50'"
                  @click="varForm.mode='fk'"
              >
                متغیر کالای موجود
              </button>
              <button
                  type="button"
                  class="px-3 py-1.5 text-xs transition"
                  :class="varForm.mode==='manual'
              ? 'bg-indigo-200 text-white'
              : 'text-gray-700 hover:bg-gray-50'"
                  @click="varForm.mode='manual'"
              >
                متغیر کالای جدید
              </button>
            </div>

            <div v-if="varForm.mode==='fk'" class="space-y-2">
              <label class="text-xs text-gray-700">انتخاب کالای موجود</label>
              <products-select
                  product_type="variable,simple"
                  v-model="varForm.product_id"
              ></products-select>
            </div>

            <div v-else class="grid grid-cols-1 gap-3">
              <div>
                <label class="text-xs text-gray-700">نام کالای جدید</label>
                <input
                    type="text"
                    v-model.trim="varForm.variation_name"
                    class="w-full px-2 py-2 rounded-lg ring-1 ring-gray-200 focus:ring-emerald-400 text-sm"
                    placeholder="نام اولیه"
                />
              </div>
            </div>
          </div>

          <div
              class="rounded-md bg-white ring-1 ring-gray-200 p-2"
              v-if="isBulkVar || (!isBulkVar && varTargetItems && varTargetItems.length)"
          >
            <div class="text-xs text-gray-700 mb-2">
              اعمال روی
              <b>{{ isBulkVar ? selectedIds.length : 1 }}</b>
              مورد:
            </div>
            <div class="space-y-2 max-h-44 overflow-auto">
              <div
                  v-for="it in varTargetItems"
                  :key="it.item_id"
                  class="flex items-center gap-2 p-2 rounded border border-gray-200"
              >
                <img
                    v-if="it.image"
                    :src="img_source(it.image)"
                    class="w-8 h-8 rounded border object-cover"
                />
                <div class="flex-1 min-w-0">
                  <div class="text-[11px] text-gray-800 truncate font-mono">
                    {{ it.sku || '-' }}
                  </div>
                  <div class="text-[10px] text-gray-500 truncate">
                    {{ it.name }}
                  </div>
                </div>

                <button
                    v-if="isBulkVar"
                    class="text-xs px-2 py-1 rounded bg-gray-100 ring-1 ring-gray-300 text-gray-700"
                    @click="removeFromSelection(it.item_id)"
                >
                  حذف
                </button>
              </div>

              <div v-if="isBulkVar && !varTargetItems.length" class="text-center text-xs text-gray-400 py-4">
                هیچ موردی انتخاب نشده.
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="mt-4 flex items-center justify-end gap-2">
          <button class="px-3 py-1.5 rounded-lg bg-gray-100 text-gray-700 text-xs" @click="closeVarModal">
            انصراف
          </button>
          <button
              class="px-3 py-1.5 rounded-lg bg-emerald-600 text-white text-xs disabled:bg-gray-400"
              :disabled="!canSubmitVar"
              @click="submitVariation"
          >
            ثبت
          </button>
        </div>
      </div>
    </div>
    <div
        v-if="showSplitModal && splitTargetItem"
        class="fixed inset-0 z-[9998] flex items-center justify-center"
        @click.self="closeSplitModal"
    >
      <div class="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>

      <div class="relative bg-white rounded-xl shadow-xl w-[92vw] max-w-2xl p-4">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-sm font-semibold">
            تقسیم آیتم
            <span class="font-mono text-gray-500">({{ splitTargetItem.sku }})</span>
          </h3>
          <button class="text-gray-500 hover:text-gray-700 text-sm" @click="closeSplitModal">
            بستن
          </button>
        </div>

        <div class="space-y-4">
          <!-- اطلاعات آیتم اصلی -->
          <div class="bg-gray-50 rounded-lg p-3 border border-gray-200">
            <div class="flex items-center gap-3">
              <img
                  v-if="splitTargetItem.image"
                  :src="img_source(splitTargetItem.image)"
                  class="w-12 h-12 rounded border object-cover"
              />
              <div class="flex-1">
                <div class="font-mono text-sm">{{ splitTargetItem.sku }}</div>
                <div class="text-xs text-gray-600">{{ splitTargetItem.name }}</div>
              </div>
              <div class="text-left">
                <div class="text-xs text-gray-500">تعداد کل:</div>
                <div class="font-bold text-sm">{{ splitTargetItem.planned }}</div>
              </div>
            </div>
          </div>

          <!-- لیست تقسیم‌ها -->
          <div class="space-y-3">
            <div class="flex items-center justify-between">
              <label class="text-xs font-medium text-gray-700">لیست آیتم‌های متغیر سازی شده</label>
              <button
                  type="button"
                  class="px-2 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700"
                  @click="addSplitRow"
                  :disabled="splitForm.splits.length >= 10"
              >
                + افزودن متغیر
              </button>
            </div>

            <div class="space-y-2 max-h-60 overflow-auto">
              <div
                  v-for="(split, index) in splitForm.splits"
                  :key="index"
                  class="flex items-center gap-2 p-3 border border-gray-200 rounded-lg"
              >
                <div class="flex-1 grid grid-cols-1 md:grid-cols-3 gap-2">
                  <div>
                    <label class="block text-xs text-gray-600 mb-1">SKU</label>
                    <input
                        type="text"
                        v-model.trim="split.sku"
                        class="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="SKU جدید"
                    />
                  </div>
                  <div>
                    <label class="block text-xs text-gray-600 mb-1">نام</label>
                    <input
                        type="text"
                        v-model.trim="split.name"
                        class="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="نام جدید"
                    />
                  </div>
                  <div>
                    <label class="block text-xs text-gray-600 mb-1">تعداد</label>
                    <input
                        type="number"
                        v-model.number="split.total_quantity"
                        min="1"
                        class="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-center"
                        placeholder="تعداد"
                    />
                  </div>
                </div>

                <button
                    v-if="splitForm.splits.length > 1"
                    type="button"
                    class="p-1 text-red-600 hover:text-red-700 hover:bg-red-50 rounded"
                    @click="removeSplitRow(index)"
                    title="حذف ردیف"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                  </svg>
                </button>
              </div>
            </div>

            <div class="flex items-center justify-between p-2 rounded border border-gray-200 bg-gray-50">
              <span class="text-xs text-gray-700">جمع تعداد:</span>
                        <span class="text-sm font-bold text-gray-800">
              {{ totalSplitQuantity }}
              <span class="text-xs text-gray-500 mr-1">از {{ splitTargetItem.planned }}</span>
            </span>
            </div>
            <div v-if="hasQuantityDifference"
                  class="text-xs p-2 rounded border"
                  :class="splitQuantityDifference < 0
                 ? 'bg-amber-50 text-amber-700 border-amber-200'
                 : 'bg-blue-50 text-blue-700 border-blue-200'">
                <span v-if="splitQuantityDifference < 0">
                  ⚠️ جمع تعداد کمتر از مقدار اصلی است
                  <span class="font-bold">({{ Math.abs(splitQuantityDifference) }} عدد کمبود)</span>
                </span>
                            <span v-else>
                  ℹ️ جمع تعداد بیشتر از مقدار اصلی است
                  <span class="font-bold">({{ splitQuantityDifference }} عدد اضافه)</span>
                </span>
            </div>
            <div v-else class="text-xs p-2 rounded border bg-green-50 text-green-700 border-green-200">
              ✓ جمع تعداد با مقدار اصلی برابر است
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="mt-6 flex items-center justify-end gap-2">
          <button
              class="px-4 py-2 text-xs bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
              @click="closeSplitModal"
          >
            انصراف
          </button>
          <button
              class="px-4 py-2 text-xs bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
              :disabled="!canSubmitSplit || submittingSplit"
              @click="submitSplit"
          >
            <span v-if="submittingSplit">در حال ثبت...</span>
            <span v-else>ثبت تقسیم</span>
          </button>
        </div>
      </div>
    </div>
    <div
        v-if="showImagePreview"
        class="fixed inset-0 z-[9999] flex items-center justify-center"
        @click.self="closeImagePreview"
    >
      <div class="absolute inset-0 bg-black/70 backdrop-blur-sm"></div>

      <div class="relative max-w-[92vw] max-h-[88vh] p-2">
        <button
            class="absolute -top-3 -right-3 bg-white text-gray-700 rounded-full shadow px-2 py-1 text-xs"
            @click="closeImagePreview"
            aria-label="بستن"
            title="بستن"
        >
          ✕
        </button>
        <img
            :src="imagePreviewSrc"
            alt="preview"
            class="block max-w-[92vw] max-h-[85vh] object-contain rounded-lg shadow-2xl"
            @click.stop
        />
      </div>
    </div>


    <div v-if="showFinishModal" class="fixed inset-0 z-[9998] flex items-center justify-center"
         @click.self="goToDeliveryDetail(finishInfo.delivery_id)">
      <div class="absolute inset-0 bg-black/40 backdrop-blur-lg"></div>
      <div class="relative bg-white rounded-xl shadow-xl w-[92vw] max-w-md p-5 text-center">
        <h3 class="text-center font-semibold mb-2">تحویل ثبت شد ✅</h3>
        <div class="flex items-center justify-end gap-2">
          <button class=" block w-full px-3 py-1.5 rounded-lg bg-blue-600 text-white text-sm mt-3 text-center"
                  @click="goToDeliveryDetail(finishInfo.delivery_id)">
            رفتن به صفحه تحویل
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductsSelect from "@/components/selects/ProductSelect";
export default {
  name: 'ChinaDeliveryCounting',
  components: {ProductsSelect},
  props: {
    packageId: {type: [String, Number], required: true},
    basePath: {type: String, default: 'deliver/china-delivery-sessions/'},
  },
  data() {
    return {
      showPrintDropdown: false,
      printMode: 'html',
      showImagePreview: false,
      imagePreviewSrc: null,
      showSplitModal: false,
      splitTargetItem: null,
      splitForm: {
        splits: [
          { sku: '', name: '', total_quantity: null }
        ]
      },
      submittingSplit: false,
      editingName: false,
      newName: "",
      savingName: false,
      selectionMode: false,
      showSelectionDropdown: false,
      searchSKUToAdd: '',
      selectedIds: [],
      showVarModal: false,
      isBulkVar: false,
      submittingVar: false,
      varForm: {
        type: 'variation',
        mode: 'manual',
        product_id: null,
        variation_name: '',
        variation_sku: '',
        targetItemId: null,
      },
      editingSku: false,
      newSku: "",
      savingSku: false,
      editingPlanned: false,
      newPlanned: null,
      savingPlanned: false,
      session : null,
      showLinesModal: false,
      linesModalItem: null,
      stores: [],
      selectedStoreId: null,
      items: [],
      lines: [],
      openForm: {
        delivery_date: this.todayStr(),
        driver_name: '',
        driver_mobile_number: '',
        document_number: '',
        total_boxes: 0,
        to_store_id: null,
      },
      skuSearch: '',
      selectedItem: null,
      suggestIndex: -1,
      scanQty: null,

      rowQty: {},
      loading: {items: false, lines: false, opening: false},
      refreshing: false,
      closing: false,
      notice: null,
      itemNameCache: {},
      _debounceTimer: null,
      toasts: [],
      showFinishModal: false,
      finishInfo: {},
    }
  },
  computed: {


    selectedItemPrice() {
      if (!this.selectedItem) return 0
      if (this.selectedItem.currency && this.selectedItem.currency.exchange_rate_to_toman) {
        return (this.selectedItem.regular_price || 0) / this.selectedItem.currency.exchange_rate_to_toman
      }
      return this.selectedItem.regular_price || this.selectedItem.price || 0
    },

    totalSplitQuantity() {
      return this.splitForm.splits.reduce((sum, split) => {
        return sum + (Number(split.total_quantity) || 0)
      }, 0)
    },

    maxQuantityForSplit() {
      // const used = this.totalSplitQuantity
      // const remaining = (this.splitTargetItem?.planned || 0) - used
      // return remaining
      return null
    },

    canSubmitSplit() {
      // if (!this.splitTargetItem) return false
      // if (this.totalSplitQuantity !== this.splitTargetItem.planned) return false
      // return this.splitForm.splits.every(split =>
      //     split.sku.trim() &&
      //     split.name.trim() &&
      //     split.total_quantity > 0
      // )
      if (!this.splitTargetItem) return false
      const allFieldsFilled = this.splitForm.splits.every(split =>
          split.sku.trim() &&
          split.name.trim() &&
          split.total_quantity > 0
      )

      return allFieldsFilled

    },
    splitQuantityDifference() {
      if (!this.splitTargetItem) return 0
      return this.totalSplitQuantity - this.splitTargetItem.planned
    },

    hasQuantityDifference() {
      return this.splitQuantityDifference !== 0
    },


    isAllSelected() {
      const ids = this.sortedItems.map(x => x.item_id)
      return ids.length > 0 && ids.every(id => this.selectedIds.includes(id))
    },
    canSubmitVar() {
      if (this.varForm.type === 'simple') return true
      if (this.varForm.mode === 'fk') {
        return !!this.varForm.product_id
      }
      return !!this.varForm.variation_name
    },
    selectedItems() {
      const id_set = new Set(this.selectedIds)
      return this.items.filter(it => id_set.has(it.item_id))
    },
    varTargetItems() {
      if (this.isBulkVar) return this.selectedItems
      if (!this.varForm.targetItemId) return []
      const it = this.items.find(x => x.item_id === this.varForm.targetItemId)
      return it ? [it] : []
    },
    selectedPlanned() {
      return this.selectedItem ? Number(this.selectedItem.planned || 0) : 0;
    },
    selectedDeliveredToDate() {
      return this.selectedItem ? Number(this.selectedItem.delivered_to_date || 0) : 0;
    },
    selectedCountedInThisSession() {
      return this.selectedItem ? Number(this.selectedItem.counted_in_this_session || 0) : 0;
    },
    filteredItems() {
      if (this.selectedItem) {
        return this.items.filter(i => i.sku === this.selectedItem.sku)
      }
      const q = (this.skuSearch || '').toLowerCase().trim()
      if (!q) return this.items
      return this.items.filter(i => i.sku && i.sku.toLowerCase().includes(q))
    },
    sortedItems() {
      // فهرست فیلترشده را کپی می‌کنیم تا تغییر نکند
      const list = [...this.filteredItems];

      const isVar = (it) => it?.type === 'variation' && it.variation_of_product_id != null;
      const baseOrder = (it) => Number(it._order ?? 0);

      // اولین جایگاه (order) هر گروه variation برای اینکه کل گروه کنار هم بمانند
      const groupFirstOrder = {};
      for (const it of list) {
        if (isVar(it)) {
          const gid = Number(it.variation_of_product_id);
          const ord = baseOrder(it);
          if (groupFirstOrder[gid] == null || ord < groupFirstOrder[gid]) {
            groupFirstOrder[gid] = ord;
          }
        }
      }

      // مرتب‌سازی:
      // 1) آیتم‌های Variation اول، بعد ساده‌ها
      // 2) بین گروه‌های Variation، بر اساس اولین جایگاه همان گروه (پایدار و مطابق ترتیب اولیه)
      // 3) داخل هر گروه Variation بر اساس ترتیب اولیه‌ی هر آیتم
      // 4) آیتم‌های ساده صرفاً با ترتیب اولیه
      return list.sort((a, b) => {
        const av = isVar(a), bv = isVar(b);
        if (av !== bv) return av ? -1 : 1; // variation ها جلوتر از ساده‌ها

        if (av && bv) {
          const ga = Number(a.variation_of_product_id);
          const gb = Number(b.variation_of_product_id);
          if (ga !== gb) return (groupFirstOrder[ga] ?? 0) - (groupFirstOrder[gb] ?? 0);
          return baseOrder(a) - baseOrder(b); // داخل گروه
        }

        // هر دو ساده
        return baseOrder(a) - baseOrder(b);
      });
    },
    filteredLines() {
      if (this.selectedItem) {
        return this.lines.filter(
            ln => ln.sku === this.selectedItem.sku || ln.package_item === this.selectedItem.item_id
        )
      }
      const q = (this.skuSearch || '').toLowerCase().trim()
      if (!q) return this.lines
      return this.lines.filter(ln => (ln.sku || '').toLowerCase().includes(q))
    },
    showSuggest() {
      return !!this.skuSearch && !this.selectedItem && this.suggestList.length >= 0
    },
    suggestList() {
      const q = (this.skuSearch || '').toLowerCase().trim()
      if (!q) return []
      return this.items.filter(it => it.sku && it.sku.toLowerCase().includes(q)).slice(0, 20)
    },
    selectedRemaining() {
      return this.selectedItem ? Number(this.selectedItem.remaining || 0) : 0
    },
    displayRemaining() {
      const qty = Number(this.scanQty || 0)
      const base = this.selectedRemaining
      if (!this.selectedItem) return 0
      if (!qty || isNaN(qty)) return base
      return Math.max(0, base - qty)
    },
    canAdd() {
      return !!this.session &&
          !this.session.is_closed &&
          !!this.selectedItem &&
          !!this.scanQty &&
          this.scanQty > 0 &&
          this.scanQty <= this.selectedRemaining &&
          this.selectedRemaining > 0
    },
  },
  created() {
    this.checkSession()
    this.fetchStores()
  },
  mounted() {
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.showImagePreview) this.closeImagePreview();
    });
    document.addEventListener('click', this.closePrintDropdown);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', () => {});
    document.removeEventListener('click', this.closePrintDropdown); // اضافه کن
  },
  methods: {

    generateSku() {
      // 13 رقم: 4 رقم اول 9999 + 9 رقم تصادفی
      const randomPart = Math.floor(Math.random() * 1000000000).toString().padStart(9, '0');
      const newSku = '9999' + randomPart;

      // مقدار رو توی newSku قرار بده
      this.newSku = newSku;

      // (اختیاری) نمایش نوتیفیکیشن
      this.showNotif('SKU با موفقیت تولید شد');
    },



    togglePrintDropdown() {
      this.showPrintDropdown = !this.showPrintDropdown
    },

    closePrintDropdown(e) {
      if (this.$refs.printDropdownContainer &&
          !this.$refs.printDropdownContainer.contains(e.target)) {
        this.showPrintDropdown = false
      }
    },

    printLabel(type) {
      if (!this.selectedItem) {
        this.showNotif('ابتدا یک آیتم انتخاب کنید', 'error', 3000)
        return
      }

      // بستن dropdown
      this.showPrintDropdown = false

      // آماده‌سازی داده‌ها
      const item = this.selectedItem
      console.log(this.selectedItem.sku)

      // تاریخ‌ها رو فرمت کن
      const expiredDate = item.expired_date || this.calcExpiredDate()
      const productDate = item.product_date || this.calcProductDate(expiredDate)

      // ساخت URL براساس نوع لیبل (با prefix product/)
      let url = ''
      const baseUrl = this.endpoint('product/') // اینجا product/ اضافه شد

      switch(type) {
        case 'price':
          url = `${baseUrl}custom-priceLabelSku/`  // changed from priceLabelSku to custom-priceLabelSku
          break
        case 'tester':
          url = `${baseUrl}custom-labelForTester/`  // changed from labelForTester to custom-labelForTester
          break
        case 'gtn':
          url = `${baseUrl}custom-priceLabel/`  // changed from priceLabel to custom-priceLabel
          break
      }

      const params = new URLSearchParams({
        gtn: this.selectedItem.sku,
        sale_price: item.sale_price || '0',
        price: item.price || item.sale_price || 0,
        expired_date: expiredDate,
        product_date: productDate,
        uid: `item-${item.item_id}`,
        name: item.name + item.variation_of_product_name || '',
        symbol: item.currency?.symbol || '¥',
        mode: this.printMode
      })

      // نهایت URL
      const fullUrl = `${url}?${params.toString()}&token=${this.token}`

      // همه حالت‌ها رو با window.open باز کن (مثل نمونه‌ای که دادی)
      window.open(fullUrl, '_blank')

    },
    calcExpiredDate() {
      // یه تاریخ پیش‌فرض یا از تنظیمات
      const d = new Date()
      d.setFullYear(d.getFullYear() + 2) // دو سال بعد
      return d.toISOString().split('T')[0]
    },

    calcProductDate(expiredDate) {
      if (!expiredDate) return this.todayStr()
      const d = new Date(expiredDate)
      d.setFullYear(d.getFullYear() - 4) // 4 سال قبل از انقضا
      return d.toISOString().split('T')[0]
    },


    groupRowIndex(idx) {
      const cur = this.sortedItems[idx];
      const key = this.groupKey(cur);
      if (!key) return 0;
      let i = idx - 1, pos = 0;
      while (i >= 0 && this.groupKey(this.sortedItems[i]) === key) { pos++; i--; }
      return pos;
    },
    rowStyle(it, idx) {
      const s = {};

      if (it && this.isVariation(it)) {
        const done = this.isDone(it);
        const key = String(it.variation_of_product_id || '');
        const hBase = this.hashCode(key);

        if (done) {
          const hue = 120 + (hBase % 40);
          s.backgroundColor = `hsl(${hue} 55% 88%)`;
        } else {
          let hue = (hBase * 37) % 360;
          if (hue >= 90 && hue <= 170) hue = (hue + 80) % 360;
          s.backgroundColor = `hsl(${hue} 70% 92%)`;
        }
      }

      const hasPrev = idx > 0;
      const hasNext = idx < this.sortedItems.length - 1;

      if (this.isGroupStart(idx) && hasPrev) {
        s.borderTop = '50px solid rgba(255,255,255)';
      }
      if (this.isGroupEnd(idx) && hasNext) {
        s.borderBottom = '50px solid rgba(255,255,255)';
      }

      return s;
    },
    openImagePreview(src) {
      if (!src) return;
      this.imagePreviewSrc = src;
      this.showImagePreview = true;
    },
    closeImagePreview() {
      this.showImagePreview = false;
      this.imagePreviewSrc = null;
    },
    hashCode(str) {
      let h = 0;
      for (let i = 0; i < str.length; i++) {
        h = (h << 5) - h + str.charCodeAt(i);
        h |= 0;
      }
      return Math.abs(h);
    },
    isDone(it) {
      return Number(it?.remaining || 0) <= 0;
    },
    isVariation(it) {
      return it && it.type === 'variation' && it.variation_of_product_id != null;
    },
    groupKey(it) {
      if (!this.isVariation(it)) return null;
      return `V-${String(it.variation_of_product_id)}`;
    },
    isSameGroup(a, b) {
      if (!a || !b) return false;
      const ka = this.groupKey(a), kb = this.groupKey(b);
      return !!ka && ka === kb;
    },

    groupColorIndex(it) {
      const id = Number(it?.variation_of_product_id || 0);
      return Math.abs(id) % 6;
    },
    isGroupStart(idx) {
      const cur = this.sortedItems[idx];
      const prev = this.sortedItems[idx - 1];
      const ck = this.groupKey(cur);
      const pk = prev ? this.groupKey(prev) : null;
      return ck && ck !== pk;
    },
    isGroupEnd(idx) {
      const cur = this.sortedItems[idx];
      const next = this.sortedItems[idx + 1];
      const ck = this.groupKey(cur);
      const nk = next ? this.groupKey(next) : null;
      return ck && ck !== nk;
    },

    groupBgClass(it) {
      const key = this.groupKey(it);
      if (!key) return '';
      const idx = this.groupColorIndex(key);
      return `group-bg-${idx}`;
    },

    rowClasses(it, idx) {
      const classes = [];

      const done = this.isDone(it);

      if (done) {
        if (this.isVariation(it)) {
          const gi = this.groupColorIndex(it); // 0..5
          classes.push(`bg-done-var-${gi}`, 'row-done');
        } else {
          classes.push('bg-done-simple', 'row-done');
        }
      } else {
        if (this.isVariation(it)) {
          const gi = this.groupColorIndex(it);
          classes.push(`bg-open-var-${gi}`, 'row-open-var');
        } else {
          // ساده و ناتمام: بدون پس‌زمینه خاص
        }
      }

      if (this.groupKey(it)) {
        if (this.isGroupStart(idx)) classes.push('group-start');
        if (this.isGroupEnd(idx)) classes.push('group-end');
      }

      if (!done) classes.push('hover:bg-gray-50');

      return classes;
    },

    validateSplitQuantity(split, index) {
      if (split.total_quantity < 0) {
        this.$set(this.splitForm.splits, index, {
          ...split,
          total_quantity: 0
        })
      }
    },

    openSplitModal(item) {
      this.splitTargetItem = item
      this.splitForm.splits = [
        { sku: '', name: '', total_quantity: null }
      ]
      this.showSplitModal = true
    },

    closeSplitModal() {
      this.showSplitModal = false
      this.splitTargetItem = null
      this.splitForm.splits = [{ sku: '', name: '', total_quantity: null }]
      this.submittingSplit = false
    },

    addSplitRow() {
      if (this.splitForm.splits.length < 10) {
        this.splitForm.splits.push({ sku: '', name: '', total_quantity: null })
      }
    },

    removeSplitRow(index) {
      if (this.splitForm.splits.length > 1) {
        this.splitForm.splits.splice(index, 1)
      }
    },

    async submitSplit() {
      if (!this.canSubmitSplit || !this.session || !this.splitTargetItem) return

      this.submittingSplit = true
      try {
        const payload = {
          item_id: this.splitTargetItem.item_id,
          splits: this.splitForm.splits.map(split => ({
            sku: split.sku,
            name: split.name,
            total_quantity: Number(split.total_quantity)
          }))
        }

        const res = await this.requestAsync({
          url: this.endpoint(`${this.basePath}${this.session.id}/split-item`),
          method: 'post',
          data: payload,
        })

        this.showNotif('آیتم با موفقیت متغیر سازی شد شد')
        this.closeSplitModal()
        await this.refreshAll()

      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در متغیر سازی آیتم', 'error', 4500)
      } finally {
        this.submittingSplit = false
      }
    },

    requestAsync(opts) {
      return new Promise((resolve, reject) => {
        this.request({
          ...opts,
          success: (res) => {
            const status = res?.status ?? res?.response?.status;
            const looksLikeError =
                (typeof status === 'number' && status >= 400) ||
                res?.ok === false ||
                res?.error ||
                res?.errors;

            if (looksLikeError) {
              return reject(res);
            }
            resolve(res);
          },
          error: (err) => reject(err),
        });
      });
    },
    startEditName() {
      if (!this.selectedItem || (this.session && this.session.is_closed)) return;
      this.savingName = false;
      this.editingSku = false;
      this.editingPlanned = false;
      this.editingName = true;
      this.newName = this.selectedItem.name || "";
    },
    cancelEditName() {
      this.savingName = false;
      this.editingName = false;
      this.newName = "";
    },
    async saveNameChange() {
      if (!this.selectedItem || !this.newName || this.savingName) return;
      this.savingName = true;
      try {
        const payload = { item_id: this.selectedItem.item_id, new_name: (this.newName || "").trim() };

        const res = await this.requestAsync({
          url: this.endpoint(`${this.basePath}${this.session.id}/change-item-name`),
          method: "post",
          data: payload,
        });

        this.selectedItem.name = res.new_name;
        const idx = this.items.findIndex(i => i.item_id === this.selectedItem.item_id);
        if (idx !== -1) this.$set(this.items, idx, { ...this.items[idx], name: res.new_name });

        this.itemNameCache[this.selectedItem.item_id] = res.new_name;

        this.showNotif('نام آیتم با موفقیت تغییر کرد');
        this.editingName = false;
        await this.refreshAll();
      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در تغییر نام آیتم', 'error', 4000);
      } finally {
        this.savingName = false;
      }
    },
    selectItemTypeForChange(it){
      this.toggleSelectionMode(true)
      if (!this.selectedIds.includes(it.item_id)) this.selectedIds.push(it.item_id)
      this.openVariationModalBulk()
    },
    toggleSelectionMode(on) {
      this.selectionMode = on
      this.showSelectionDropdown = false
      if (!on) this.selectedIds = []
      this.savingSku = false;
      this.savingPlanned = false;
    },
    removeFromSelection(id) {
      this.selectedIds = this.selectedIds.filter(x => x !== id)
    },
    clearSelection() {
      this.selectedIds = []
    },
    addSkuToSelection() {
      const sku = (this.searchSKUToAdd || '').trim()
      if (!sku) return
      const it = this.items.find(x => (x.sku || '').toLowerCase() === sku.toLowerCase())
      if (!it) {
        this.showNotif('SKU یافت نشد', 'error', 3000)
        return
      }
      if (!this.selectedIds.includes(it.item_id)) this.selectedIds.push(it.item_id)
      this.searchSKUToAdd = ''
    },

    openVariationModalSingle(it) {
      this.isBulkVar = false
      this.varForm.targetItemId = it.item_id
      this.prefillVarFormFromItem(it)
      this.showVarModal = true
    },

    openVariationModalBulk() {
      this.isBulkVar = true
      this.varForm.targetItemId = null
      this.varForm.type = 'variation'
      this.varForm.mode = 'fk'
      this.varForm.product_id = null
      this.varForm.variation_name = ''
      this.varForm.variation_sku = ''
      this.showVarModal = true
      this.showSelectionDropdown = false
    },

    prefillVarFormFromItem(it) {
      if (it.type === 'variation') {
        if (it.variation_name || it.variation_sku) {
          this.varForm.type = 'variation'
          this.varForm.mode = 'manual'
          this.varForm.variation_name = it.variation_name || ''
          this.varForm.variation_sku = it.variation_sku || ''
          this.varForm.product_id = null
        } else {
          this.varForm.type = 'variation'
          this.varForm.mode = 'fk'
          this.varForm.product_id = it.variation_of_product_id || null
          this.varForm.variation_name = ''
          this.varForm.variation_sku = ''
        }
      } else {
        this.varForm.type = 'variation'
        this.varForm.mode = 'fk'
        this.varForm.product_id = null
        this.varForm.variation_name = ''
        this.varForm.variation_sku = ''
      }
    },

    async submitVariation() {
      if (!this.canSubmitVar || !this.session) return;

      this.submittingVar = true;
      try {
        const base =
            this.varForm.type === 'simple'
                ? { type: 'simple' }
                : (this.varForm.mode === 'fk'
                    ? { type: 'variation', variation_of_product_id: this.varForm.product_id }
                    : { type: 'variation', variation_name: this.varForm.variation_name, variation_sku: '' });

        if (this.isBulkVar) {
          const items = this.selectedIds.map(id => ({ item_id: id, ...base }));
          await this.requestAsync({
            url: this.endpoint(`${this.basePath}${this.session.id}/set-item-variation-bulk`),
            method: 'post',
            data: { items },
          });
        } else {
          await this.requestAsync({
            url: this.endpoint(`${this.basePath}${this.session.id}/set-item-variation`),
            method: 'post',
            data: { item_id: this.varForm.targetItemId, ...base },
          });
        }
        this.toggleSelectionMode(false);
        this.showSelectionDropdown = false;
        this.showVarModal = false;
        this.isBulkVar = false;
        this.resetVarForm();
        this.showNotif('تغییر نوع ثبت شد');

        await this.loadItems();

      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در ثبت تغییر نوع', 'error', 4500);
      } finally {
        this.submittingVar = false;
      }
    },

    closeVarModal() {
      this.showVarModal = false
    },
    toggleSelectAll(e) {
      if (e.target.checked) {
        this.selectedIds = this.sortedItems.map(x => x.item_id)
      } else {
        this.selectedIds = []
      }
    },

    resetVarForm() {
      this.varForm.type = 'simple'
      this.varForm.mode = 'fk'
      this.varForm.product_id = null
      this.varForm.variation_name = ''
      this.varForm.variation_sku = ''
    },

    startEditPlanned() {
      if (!this.selectedItem || (this.session && this.session.is_closed)) return;
      this.savingPlanned = false;
      this.editingName = false;
      this.editingSku = false;
      this.editingPlanned = true;
      this.newPlanned = this.selectedPlanned;
    },
    cancelEditPlanned() {
      this.savingPlanned = false;
      this.editingPlanned = false;
      this.newPlanned = null;
    },
    async savePlannedChange() {
      if (!this.selectedItem || this.newPlanned == null || this.savingPlanned) return;
      this.savingPlanned = true;
      try {
        const payload = { item_id: this.selectedItem.item_id, new_planned: Number(this.newPlanned) };
        const res = await this.requestAsync({
          url: this.endpoint(`${this.basePath}${this.session.id}/change-item-planned`),
          method: "post",
          data: payload,
        });

        const idx = this.items.findIndex(i => i.item_id === this.selectedItem.item_id);
        if (idx !== -1) {
          const next = {
            ...this.items[idx],
            planned: res.total_quantity,
            delivered_to_date: res.delivered_to_date,
            counted_in_this_session: res.counted_in_this_session,
            remaining: res.remaining,
          };
          this.$set(this.items, idx, next);
          this.selectedItem = next;
        }

        this.showNotif('تعداد کل با موفقیت تغییر کرد');
        this.editingPlanned = false;
        await this.refreshAll();
      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در تغییر تعداد کل', 'error', 4000);
      } finally {
        this.savingPlanned = false;
      }
    },

    startEditSku() {
      if (!this.selectedItem || (this.session && this.session.is_closed)) return;
      this.savingSku = false;
      this.editingSku = true;
      this.editingName = false;
      this.editingPlanned = false;
      this.newSku = this.selectedItem.sku || "";
    },
    cancelEditSku() {
      this.savingSku = false;
      this.editingSku = false;
      this.newSku = "";
    },
    async saveSkuChange() {
      if (!this.selectedItem || !this.newSku || this.savingSku) return;
      this.savingSku = true;
      try {
        const payload = { item_id: this.selectedItem.item_id, new_sku: (this.newSku || "").trim() };

        const res = await this.requestAsync({
          url: this.endpoint(`${this.basePath}${this.session.id}/change-item-sku`),
          method: "post",
          data: payload,
        });

        this.selectedItem.sku = res.sku;
        const idx = this.items.findIndex(i => i.item_id === this.selectedItem.item_id);
        if (idx !== -1) this.$set(this.items, idx, { ...this.items[idx], sku: res.sku });

        this.skuSearch = res.sku;
        this.showNotif('SKU با موفقیت تغییر کرد');
        this.editingSku = false;
        await this.refreshAll();

      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در تغییر SKU', 'error', 4000);
      } finally {
        this.savingSku = false;
      }
    },
    lastLinesForItem(itemId, limit = 5) {
      const list = this.lines
          .filter(ln => ln.package_item === itemId)
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      return list.slice(0, limit);
    },
    openLinesModal(it) {
      this.linesModalItem = it
      this.showLinesModal = true
      this.loadLines()
    },
    closeLinesModal() {
      this.showLinesModal = false
      this.linesModalItem = null
    },
    linesForItemId(itemId) {
      return this.lines.filter(ln => ln.package_item === itemId)
    },

    removeToast(id) {
      this.toasts = this.toasts.filter(t => t.id !== id)
    },

    goToDeliveryDetail(deliver) {
      this.$router.push(`/panel/deliverInsert/${deliver}`)
    },
    clampQty() {
      if (!this.selectedItem) return
      const max = Math.max(0, this.selectedRemaining)
      if (this.scanQty == null) return
      if (this.scanQty > max) this.scanQty = max
      if (this.scanQty < 1 && max >= 1) this.scanQty = 0
    },

    clearSelected() {
      this.selectedItem = null
      this.skuSearch = ''
      this.scanQty = null
    },
    onSkuTyping() {
      if (this.selectedItem && this.skuSearch !== this.selectedItem.sku) {
        this.selectedItem = null
        this.scanQty = null
      }
      this.debouncedLoadItems()
    },
    fetchStores() {
      this.request({
        url: this.endpoint(`main/store`),
        method: "get",
        success: (data) => {
          this.stores = Array.isArray(data) ? data : []
        },
        fail: (e) => this.showNotif(this.extractErr(e) || 'خطا در دریافت انبارها', 'error', 4000),
      })
    },

    checkSession() {
      this.refreshing = true
      this.request({
        url: this.endpoint(`${this.basePath}by-package?package_id=${this.packageId}`),
        method: 'get',
        success: (data) => {
          this.showNotif('تحویل در حال انجام', 'success', 4000)
          this.session = data
          this.openForm.driver_name = data.driver_name || ''
          this.openForm.driver_mobile_number = data.driver_mobile_number || ''
          this.openForm.document_number = data.document_number || ''
          if (data.to_store) {
            this.openForm.to_store_id = data.to_store.id
          } else {
            this.openForm.to_store_id = null
          }
          this.selectedStoreId = this.openForm.to_store_id
          this.refreshAll()
        },
        fail: (e) => {
          if (!(e && e.response && e.response.status === 404)) {
            this.showNotif('برای شروع اطلاعات را وارد کنید', 'success', 4000)
          }
        },
        finally: () => (this.refreshing = false),
      })
    },
    uuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16)
      })
    },
    todayStr() {
      const d = new Date();
      const m = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');
      return `${d.getFullYear()}-${m}-${day}`
    },
    formatDateTime(s) {
      if (!s) return '';
      const d = new Date(s);
      return d.toLocaleString()
    },
    showNotif(message, type='success', timeout=2200) {
      const id = Math.random().toString(36).slice(2)
      this.toasts.push({ id, message, type })
      if (timeout) {
        setTimeout(() => this.removeToast(id), timeout)
      }
    },
    extractErr(e) {
      try {
        if (e && e.response && e.response.data) {
          const d = e.response.data;
          if (typeof d === 'string') return d;
          if (Array.isArray(d) && d.length) return d[0]['messages'][0];
          if (d.detail) return d.detail;
          const msgs = Object.keys(d).map(k => `${k}: ${Array.isArray(d[k]) ? d[k].join(', ') : d[k]}`);
          return msgs.join(' | ')
        }
        return e && e.message
      } catch (_) {
        return 'خطای نامشخص'
      }
    },

    tryOpenOrResume() {
      this.openSession()
    },
    openSession() {
      if (this.loading.opening) return;
      this.loading.opening = true
      const payload = {
        package_id: this.packageId,
        to_store_id: this.selectedStoreId || null,
        driver_name: this.openForm.driver_name || null,
        driver_mobile_number: this.openForm.driver_mobile_number || null,
        document_number: this.openForm.document_number || null,
        note: this.openForm.note || null,
      }
      this.request({
        url: this.endpoint('deliver/china-delivery-sessions'),
        method: 'post',
        data: payload,
        success: (data) => {
          this.session = data
          this.showNotif('تحویل آغاز شد')
          this.refreshAll()
        },
        fail: (e) => this.showNotif(this.extractErr(e) || 'خطا در باز کردن/بازیابی تحویل', 'error', 4000),
        finally: () => this.loading.opening = false,
      })
    },
    refreshAll() {
      this.refreshing = true;
      Promise.all([this.loadItems(), this.loadLines()]).finally(() => this.refreshing = false)
    },

    // Items
    debouncedLoadItems() {
      clearTimeout(this._debounceTimer);
      this._debounceTimer = setTimeout(() => this.loadItems(), 220)
    },
    loadItems() {
      if (!this.session) return Promise.resolve();
      this.loading.items = true
      const url = this.endpoint(`${this.basePath}${this.session.id}/items`)
      return new Promise((resolve) => {
        const prevOrderMap = new Map(this.items.map(it => [it.item_id, it._order]))
        this.request({
          url, method: 'get', success: (data) => {
            this.items = (Array.isArray(data) ? data : []).map((it, idx) => ({
              ...it,
              _order: prevOrderMap.get(it.item_id) ?? idx, // ترتیب پایدار
            }))
            this.items.forEach(it => { this.itemNameCache[it.item_id] = it.name })
          },
          fail: (e) => this.showNotif(this.extractErr(e) || 'خطا در دریافت آیتم‌ها', 'error', 4000),
          finally: () => { this.loading.items = false; resolve() }
        })
      })
    },

    moveSuggest(step) {
      if (!this.showSuggest) return;
      const len = this.suggestList.length;
      if (!len) return;
      this.suggestIndex = ((this.suggestIndex + step) % len + len) % len
    },
    chooseSuggest() {
      if (this.suggestIndex < 0) return;
      const s = this.suggestList[this.suggestIndex];
      this.selectRow(s)
    },

    selectRow(it) {
      this.selectedItem = it;
      this.skuSearch = it.sku;
      this.scanQty = null;
      this.editingSku = false;
      this.savingSku = false;
      this.editingPlanned = false;
      this.savingPlanned = false;
      this.editingName = false;
      this.savingName = false;
      this.$nextTick(() => {
      })
    },
    addSelected() {
      if (!this.selectedItem.sku){
        this.showNotif('ابتدا SKU را وارد کنید.', 'error', 3000)
      }
      if (!this.canAdd) {
        if (this.selectedItem && this.selectedRemaining <= 0) {
          this.showNotif('این آیتم باقیمانده ندارد.', 'error', 3000)
        } else if (this.selectedItem && this.scanQty > this.selectedRemaining) {
          this.showNotif(`حداکثر مجاز: ${this.selectedRemaining}`, 'error', 3000)
        }
        return
      }
      const sku = this.selectedItem.sku
      const item_id = this.selectedItem.item_id
      const qty = Number(this.scanQty)
      const payload = {sku, qty, idempotency_key: this.uuid(), item_id: item_id}
      this.request({
        url: this.endpoint(`${this.basePath}${this.session.id}/scan`),
        method: 'post',
        data: payload,
        success: () => {
          this.showNotif('ثبت شد')
          this.refreshAll()
          this.selectedItem = null
          this.skuSearch = ''
          this.scanQty = null
        },
        fail: (e) =>
            this.showNotif(this.extractErr(e) || 'ثبت ناموفق (احتمالاً از باقیمانده بیشتر است یا SKU یافت نشد)', 'error', 4500),
      })
    },

    loadLines() {
      if (!this.session) return Promise.resolve();
      this.loading.lines = true
      return new Promise((resolve) => {
        this.request({
          url: this.endpoint(`${this.basePath}${this.session.id}/lines`),
          method: 'get',
          success: (data) => this.lines = data,
          fail: (e) => this.showNotif(this.extractErr(e) || 'خطا در دریافت ثبت‌ها', 'error', 4000),
          finally: () => {
            this.loading.lines = false;
            resolve()
          }
        })
      })
    },
    undoLine(id) {
      if (!this.session) return;
      this.request({
        url: this.endpoint(`${this.basePath}${this.session.id}/lines/${id}`),
        method: 'delete',
        success: () => {
          this.showNotif('حذف شد');
          this.refreshAll()
        },
        fail: (e) => this.showNotif(this.extractErr(e) || 'خطا در حذف ثبت', 'error', 4000)
      })
    },

    closeSession() {
      if (!this.session || this.session.is_closed) return;
      this.closing = true

      const payload = {
        ...this.openForm,
        to_store_id: this.selectedStoreId ?? this.openForm.to_store_id,
        idempotency_key: this.uuid(),
      }

      this.request({
        url: this.endpoint(`${this.basePath}${this.session.id}/close`),
        method: 'post',
        data: payload,
        success: (res) => {
          this.showNotif(`تحویل به پایان رسید. تحویل #${res.delivery_id}`)
          this.finishInfo = res
          this.showFinishModal = true
          this.session.is_closed = true
          this.$emit('closed', res)
        },
        fail: (e) => this.showNotif(this.extractErr(e) || 'بستن تحویل ناموفق بود', 'error', 4500),
        finally: () => this.closing = false
      })
    },

    lineItemName(itemId) {
      return this.itemNameCache[itemId] || `Item ${itemId}`
    },
  },
}
</script>

<style scoped>
.btn {
  @apply inline-flex items-center justify-center rounded-xl px-3 py-2 text-sm font-medium border;
}

.btn-primary {
  @apply bg-emerald-600 text-white border-emerald-600 hover:bg-emerald-700;
}

.btn-secondary {
  @apply bg-gray-100 text-gray-800 border-gray-200 hover:bg-gray-200;
}

.btn-danger {
  @apply bg-rose-600 text-white border-rose-600 hover:bg-rose-700;
}

.btn-ghost {
  @apply text-gray-500 hover:text-rose-600;
}

.th {
  @apply px-4 py-2 text-right text-xs font-semibold uppercase tracking-wider;
}

.td {
  @apply px-4 py-2;
}

.badge {
  @apply inline-flex items-center justify-center rounded-full bg-emerald-50 text-emerald-700 px-2 py-0.5 text-xs;
}

.badge-gray {
  @apply inline-flex items-center justify-center rounded-full bg-gray-100 text-gray-600 px-2 py-0.5 text-xs;
}

.pill {
  @apply inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs border border-gray-200 bg-white;
}

.pill-green {
  @apply border-emerald-200 bg-emerald-50 text-emerald-700;
}

.pill-gray {
  @apply border-gray-200 bg-gray-50 text-gray-700;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.toast-enter-active, .toast-leave-active {
  transition: all .18s ease;
}

.toast-enter-from, .toast-leave-to {
  opacity: 0;
  transform: translateY(-6px) scale(.98);
}

.bg-done-simple {
  background-color: #dcfce7;
}

.bg-done-var-0 { background-color: #dcfce7; }
.bg-done-var-1 { background-color: #bbf7d0; }
.bg-done-var-2 { background-color: #86efac; }
.bg-done-var-3 { background-color: #6ee7b7; }
.bg-done-var-4 { background-color: #a7f3d0; }
.bg-done-var-5 { background-color: #ccfbf1; }

.bg-open-var-0 { background-color: #BDD4D1; }
.bg-open-var-1 { background-color: #B0C2D4; }
.bg-open-var-2 { background-color: #D9A1C8; }
.bg-open-var-3 { background-color: #F2BFCA; }
.bg-open-var-4 { background-color: #F9D5C6; }
.bg-open-var-5 { background-color: #FFEDD6; }


tr.group-start {
  border-bottom: 8px solid transparent;
}
tr.group-end   { border-top: 8px solid transparent; }

tr.group-end + tr.group-start {
  border-top: 2px solid rgba(0, 0, 0, 0.35);
}

.bg-done-simple,
.bg-done-var-0,
.bg-done-var-1,
.bg-done-var-2,
.bg-done-var-3,
.bg-done-var-4,
.bg-done-var-5 {
  background-color: #dcfce7; /* سبز ملایم یکدست */
}


tr.row-done td {
  color: #0f172a;
}
</style>
